import { render, staticRenderFns } from "./Address.vue?vue&type=template&id=cc0b915c&scoped=true&lang=pug&"
import script from "./Address.vue?vue&type=script&lang=js&"
export * from "./Address.vue?vue&type=script&lang=js&"
import style0 from "./Address.scss?vue&type=style&index=0&id=cc0b915c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0b915c",
  null
  
)

export default component.exports